const privacyPolicy = [
  {
    id: "overview",
    title: "1. Overview",
    content: "At EliteCars, we value your privacy and are committed to protecting your personal information. This Privacy Policy outlines how we collect, use, and secure your data while delivering our premium car rental services."
  },
  {
    id: "data-privacy",
    title: "2. Data Privacy",
    content: "We collect essential personal data to provide reliable and seamless rental experiences, such as:",
    list: [
      "Customer name, contact details, and driver’s license information",
      "Rental history and booking preferences",
      "Payment and billing details for transactions",
      "Pickup/drop-off dates, times, and vehicle usage data"
    ]
  },
  {
    id: "terms-of-service",
    title: "3. Terms of Service",
    content: "Our Terms of Service govern the use of our car rental platform and vehicles. By booking with EliteCars, you agree to abide by rental policies, payment terms, usage guidelines, and return conditions."
  },
  {
    id: "user-rights",
    title: "4. User Rights",
    content: "You have the right to:",
    list: [
      "Access and update your personal and booking information",
      "Request deletion or correction of stored data",
      "Review rental history and related agreements"
    ]
  },
  {
    id: "data-security",
    title: "5. Data Security",
    content: "We use secure servers, encryption technologies, and strict access control to safeguard your personal and financial information against unauthorized access or misuse."
  },
  {
    id: "cookies",
    title: "6. Cookies",
    content: "Our website uses cookies to enhance your browsing experience, remember your booking preferences, and analyze site usage to improve service efficiency."
  },
  {
    id: "third-party",
    title: "7. Third-Party Services",
    content: "We may share data with trusted third parties for services such as payment processing, identity verification, and insurance coverage—always under strict confidentiality agreements."
  },
  {
    id: "data-storage",
    title: "8. Data Storage",
    content: "Your information is securely stored for the duration required by rental regulations and service needs. You may contact us to request specific data handling preferences."
  },
  {
    id: "data-transfers",
    title: "9. Data Transfers",
    content: "In some cases, your information may be securely transferred to trusted partners for operational purposes, such as insurance validation or payment gateways, following all legal standards."
  },
  {
    id: "policy-updates",
    title: "10. Policy Updates",
    content: "We may update this policy as our services evolve. Major changes will be communicated to users, and the latest version will always be accessible on our website."
  }
];

export default privacyPolicy;